<template>
  <div id="consulta d-flex flex-row flex-wrap justify-content-center">
    <Header :logged="logged" />

    <b-modal
      ref="modalInstrumento"
      size="xl"
      scrollable
      title="Resultado"
      id="modal-dialog"
    >

    <div  v-for="item in items" v-bind:key="item.cd_cartorio">
      <div class="card" style="padding: 10px;margin-bottom: 10px;">
        <div class="card" style="margin-bottom: 10px;background: #e1e1e1;">
          <div class="card-body">
              <p class="text-left" style="color: black;"><b>Documento:{{item.doc_devedor | documento}}</b></p>
              <p class="text-left" style="color: black;"><b>Devedor:</b>{{ item.nomeDevedor | uppert }}</p>
              <p class="text-left" style="color: black;margin: 0;"><b>Cartório/Comarca:</b>{{ item.nome_cartorio | uppert }}/{{ item.uf }}</p>
              <p class="text-left" style="color: black;margin: 0;">{{ item.endereco }} - {{ item.endereco_numero }} - {{ item.bairroc }} - {{ item.cidadec }} / {{ item.uf }} - {{ item.telefone | fone }} </p>
              <p class="text-left" style="color: black;margin: 0;"> {{ item.email }} - {{ item.hora_funcionamento }}</p>
          </div>
        </div>

        <div class="card-body" style="background: #0082C6;">
          <h3 class="text-center" style="color: #fff;">EDITAL ELETRÔNICO NA FORMA DO ART. 3º DO PROVIMENTO 87:</h3>
          <h5 class="text-center" style="color: #fff;"><u>DATA DA PUBLICAÇÃO: {{ item.dt_hr_cadastro | dataBr }}</u></h5>
          <p v-if="item.texto_edital" class="text-center" style="color: #fff;">{{ item.texto_edital }}</p>
          <p v-else class="text-center" style="color: #fff;">A este Tabelionato de Protesto foi solicitada a intimação de V.Sª para pagamento do título / documento de dívida abaixo indicado. Caso não seja efetuado o pagamento nesta serventia, dentro do prazo legal, será lavrado nos termos da lei, o respectivo Termo de Protesto.</p>
          <table  stacked class="table table-hover">
          <thead>
            <tr>
              <th style="color: #fff;" class="col-xs-4 col-sm-4 col-md-4 col-lg-4 text-center" scope="cols-4">Endereço</th>
              <th  class="col-xs-3 col-sm-2 col-md-2 col-lg-2 text-center" scope="cols-1" style="text-align: right;color: #fff;">Data de Apresentação</th>
              <!-- th  class="col-xs-1 col-sm-2 col-md-2 col-lg-2 text-center" scope="cols-2" style="text-align: right;color: #fff;">Espécie do Título</th -->
              <!-- th  class="col-xs-1 col-sm-2 col-md-2 col-lg-2 text-center" scope="cols-2" style="text-align: right;color: #fff;">*Prazo para Pagamento </th -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="it in item.editalf[0]"  v-bind:key="it.doc_devedor">
              <td style="color: #fff;" class="text-center">{{ it.bairroDevedor }}  - {{ it.cidadeDevedor}}</td>
              <td style="color: #fff;" class="text-center">{{ it.dataApresentacao | data}}</td>
              <!-- td style="color: #fff;" class="text-center">{{ it.especiedoTitulo}}</td -->
              <!-- td style="color: #fff;" class="text-center">{{ it.dataVencimento}}</td -->
            </tr>
          </tbody>
        </table>
        </div>
        <br><br>
      </div>
    </div>
      <b-button @click="hideModal2();limparInput()" block  type="button" class="mt-5" variant="primary">Realizar nova pesquisa <font-awesome-icon icon="search"/></b-button>
      <br>
    </b-modal>
    <div class="text-center">
      <b-modal ref="modalErro"  hide-footer title="Resultado" @ok="confirmar">Não existem editais publicados para o documento pesquisado!<br><b-button @click="hideModal();limparInput()" block  type="button" class="mt-5" variant="primary">Realizar nova pesquisa <font-awesome-icon icon="search"/> </b-button>
    </b-modal>
    </div>
    <div id="wrapper-spinner" v-if="exibir">
      <BeatLoader color="var(--main-azul)" />
    </div>

    <div id="consulta-form" class="d-sm-none d-md-block column-nowrap" v-if="!exibir">
      <section class="container nowrap">
        <div id="banner1" class="item"></div>
      </section>
      <div id="rodape" class="text-center">
        <h1 class="mt-3 letraConsProt"><b>Edital Eletrônico dos Cartórios de Protesto do Brasil</b></h1>
        <div id="wrapper-input" class="mt-4">
          <div id="bt-consultar" class="text-center" @click="enviarConsultaAnuencia()">VERIFICAR</div>
          <div id="wrapper-cpf_cnpj" class="text-center">
            <div id="cpf_ou_cnpj" class="text-center" @click="inputConsultaFocus()">CPF ou CNPJ</div>
            <the-mask
              :mask="['###.###.###-##', '##.###.###/####-##']"
              id="cpf_cnpj"
              v-model="cpf_cnpj"
              v-on:blur.native="verificaInputConsulta()"
              @focus.native="placeholderInputConsulta(false)"
              class="vtm"
            />
          </div>
        </div>
      </div>
      <vue-recaptcha
        ref="invisibleRecaptcha"
        @verify="onVerify"
        @expired="onExpired"
        size="invisible"
        :sitekey="sitekey"
      ></vue-recaptcha>
    </div>
  </div>
</template>

<script>
import { TheMask } from "vue-the-mask";
import Header from "../components/Header";
import API from "../services/api";
import BeatLoader from "vue-spinner/src/BeatLoader.vue";
import VueRecaptcha from "vue-recaptcha";

export default {
  components: {
    TheMask,
    Header,
    BeatLoader,
    VueRecaptcha
  },
  data() {
    return {
      sitekey: process.env.VUE_APP_sitekeyRecaptcha,
      cpf_cnpj: "",
      logged: false,
      documento: "",
      items: [],
      tok: "",
      exibir: false
    };
  },
  mounted() {
    this.$root.isLogged().then(() => {
        this.logged = true;
      }).catch(() => {
        this.logged = false;
      })
  },
  filters: {
    moeda: function (value) {
      var v = value.replace(/\D/g,'')
      v = (v/100).toFixed(2) + ''
      v = v.replace(".", ",")
      v = v.replace(/(\d)(\d{3})(\d{3}),/g, "$1.$2.$3,")
      v = v.replace(/(\d)(\d{3}),/g, "$1.$2,")
      return v
    },
    uppertitulo: function (value){
      if (!value) return ''
      value = value.toString()
      var vall = value.toLowerCase()
      return vall.charAt(0).toUpperCase() + vall.slice(1)
    },
    uppert: function (value){
      if (!value) return ''
      value = value.toString()
      return value.toUpperCase()
    },
    dataBr: function (value) {
      var str = value;
      var strSplit = str.split("-");
      var ano = strSplit[0];
      var mes = strSplit[1];
      var dia = strSplit[2].substring(0,2);
      console.log(strSplit);
      return dia +"/"+ mes +"/"+ ano ;
    },
    SomadataBr: function (value) {
      var str = value;
      var strSplit = str.split("-");
      var ano = strSplit[0];
      var mes = strSplit[1];
      var dia = strSplit[2].substring(0,2);
      var data  = new Date(ano, mes, dia);
      data.setDate(data.getDate() + 3);
      var diaf=data.getDate();
      var mesf=data.getMonth();
      var anof=data.getFullYear();
      var minhaData = diaf + '/' + mesf + '/' + anof;

      return minhaData;
    },
    fone: function (value){
      if (value != undefined) {
        var d = ''
        if(value.length > 10){
          d = value
          d = d.replace(/\D/g, "")
          d = d.replace(/^(\d\d)(\d)/g, "($1) $2")
          d = d.replace(/(\d{5})(\d)/, "$1-$2")
          return d
        }else{
          d = value
          d = d.replace(/\D/g, "")
          d = d.replace(/^(\d\d)(\d)/g, "($1) $2")
          d = d.replace(/(\d{4})(\d)/, "$1-$2")
          return d
        }
      }
    },
    documento: function (value) {
      if (value == null) {
          return '';
      } else {
          let v = value;
          //Remove tudo o que não é dígito
          v = v.replace(/\D/g, "");
          if (v.length < 14) { //CPF
              v = v.replace(/(\d{3})(\d)/, "$1.$2");
              v = v.replace(/(\d{3})(\d)/, "$1.$2");
              v = v.replace(/(\d{3})(\d{1,2})$/, "$1-$2");
          } else { //CNPJ
              v = v.replace(/^(\d{2})(\d)/, "$1.$2");
              v = v.replace(/^(\d{2})\.(\d{3})(\d)/, "$1.$2.$3");
              v = v.replace(/\.(\d{3})(\d)/, ".$1/$2");
              v = v.replace(/(\d{4})(\d)/, "$1-$2");
          }
          return v;
      }
    }
  },
  methods: {
    limparInput() {
      document.getElementById('cpf_cnpj').value="";
      document.getElementById("cpf_cnpj").focus()
  },
    hideModal() {
        this.$refs['modalErro'].hide();
      },
      hideModal2() {
        this.$refs['modalInstrumento'].hide();
      },
    //desableRC: function(e) {
    confirmar(){
      document.getElementById("cpf_cnpj").focus()
    },
    onVerify: function(response) {
      this.tok = response;
      //console.log(response);
      this.$refs.invisibleRecaptcha.reset();
      if (this.cpf_cnpj) {
        this.exibir = false;
        API.get(`/pesquisa/pesquisaEditalEletronico/${this.cpf_cnpj}/${this.tok}`)
          .then(res => {
                if(res.data.result == 1){
                    this.items = res.data['editalEletronico'];
                    this.items = res.data['editalEletronico'];
                    this.$refs["modalInstrumento"].show();
                    this.exibir = false;
                }else {
                    this.$refs["modalErro"].show();
                    this.exibir = false;
                }
          })
          .catch(()=> {
            //console.log(e);
            alert("Não foi possivel completar a solicitação");
            this.exibir = false;
          });
      }
      this.resetRecaptcha();
    },
    onExpired: function() {
      this.$refs.invisibleRecaptcha.reset();
    },
    resetRecaptcha() {
      this.$refs.invisibleRecaptcha.reset(); // Direct call reset method
    },
    solicitar(nm_chave, cpfCnpj) {
      if(nm_chave) {
        if(this.validar()){
          //  iniciando solicitação -> login / cadastro
          //  armazena a chave
          localStorage.setItem("nm_chave", nm_chave)
          localStorage.setItem("cpfCnpj", cpfCnpj)
          //  redireciona para login
          this.$router.push({ name: 'login', params: { tipo_login: 'solicitarCancelamentoAnuencia' } })
        } else {
          alert('informe o cpf')
        }
      }
    },
    enviarConsultaAnuencia() {
      this.$refs.invisibleRecaptcha.execute();
    },
    validar() {
      let len = this.cpf_cnpj.length;
      //let doc = this.cpf_cnpj
      return len == 11 || len == 14 ? true : false;
      //return len == 11 ? Serv.validarCPF(doc) : len == 14 ? Serv.validarCNPJ(doc) : false
    },
    placeholderInputConsulta(show) {
      let placeholder = document.getElementById("cpf_ou_cnpj");
      if (show) placeholder.classList.remove("hide");
      else placeholder.classList.add("hide");
    },
    verificaInputConsulta() {
      if (!this.cpf_cnpj) this.placeholderInputConsulta(true);
    },
    inputConsultaFocus() {
      document.getElementById("cpf_cnpj").focus();
    }
  }
};
</script>

<style scoped>
h1 {
  font-size: 40px;
}
h1,
p,
p {
  color: #fff;
}
p {
  font-size: 17px;
}
p > b {
  margin-right: 15px;
}
#wrapper-spinner {
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 100%;
  height: calc(100% - 80px);
}
#wrapper-spinner .v-spinner {
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -10px 0px 0px -20px;
}
#consulta-form {
  font-family: "Kanit", sans-serif !important;
}
#banner1 {
  background-image: url("~@/assets/imgs/editalEletronico.jpg");
  background-repeat: no-repeat;
  max-width:100%;
	height:auto;
  margin-top: -51px;
}
.containerB {
  max-width: 100%;
  margin: 0 auto;
  display: flex;
  border: 1px solid #ccc;
  height: 100%;
  position: absolute;
  /* margin-top: 579px; */
  width: 100%;
}
.container {
  max-width: 100%;
  margin: 0 auto;
  display: flex;
  height: 100%;
  padding-right: 0px;
  padding-left: 0px;
  position: absolute;
}
.nowrap {
  flex-wrap: nowrap;
}
.column-nowrap {
  flex-flow: column nowrap;
}
#wrapper-input {
  background-color: rgba(255, 255, 255, 0.3);
  border: 2px solid rgb(255, 255, 255) !important;
  width: 52%;
  height: 28%;
  margin-left: 25%;
  position: absolute;
  z-index: 10;
}
#cpf_ou_cnpj {
  position: absolute;
  left: 15px;
  font-size: 19px;
  letter-spacing: 0.25px;
  color: #fff;
  opacity: 1;
  transition: all 0.8s ease-out;
  font-size: 30px;
  bottom: -8px;
}
#cpf_ou_cnpj.hide {
  bottom: 0px;
  opacity: 0;
}
#cpf_cnpj {
  width: 100%;
  height: 210%;
  background: none;
  color: #fff;
  border: none;
 font-family: "Kanit", sans-serif !important;
  font-size: 32px;
  letter-spacing: 2px;
}
#bt-consultar {
  cursor: pointer;
  float: right;
  width: 45%;
  height: 84%;
  color: #fff;
  background-color: #de8800;
 font-family: "Kanit", sans-serif !important;
  font-size: 30px;
  margin-right: 8px;
  margin-top: 4px;
}
#wrapper-cpf_cnpj {
  padding: 10px 0px 10px 10px;
  position: absolute;
  width: 54%;
  height: 70% !important;
}
.itemB {
  flex: 1;
  text-align: center;
  font-size: 1.5em;
}
.item {
  /* O flex: 1; é necessário para que cada item se expanda ocupando o tamanho máximo do container. */
  flex: 1;
  text-align: center;
  font-size: 1.5em;
}
.space-around {
  justify-content: space-around;
}
.column {
  min-height: 100%;
  flex-direction: column;
}
.flex {
  flex: 1;
}
.itemB1 {
  background-color: rgba(20, 96, 118, 0.75);
}
.itemB2 {
  background-color: rgba(20, 96, 118, 0.75);
}
.itemB3 {
  background-color: #146076;
}
.itemConsulta {
  background-color: rgba(20, 96, 118, 0.75);
}
#rodape {
  background-color: #185684;
  width: 100%;
  height: 229px;
  position: absolute;
  z-index: 10;
  bottom: 0;
  margin-bottom: 0;
}
#rodapeV {
  background-color: #185684;
  width: 100%;
  height: 227px;
  position: absolute;
  z-index: 10;
  bottom: 0;
  margin-bottom: 0%;
}
.text-amarelo {
  color: #ffa20e;
}
.letraInstProt {
  font-size: 28px;
}
.letraAtencao {
  font-size: 38px;
}
@media (min-width: 320px) and (max-width: 765px) {
  h1 {
    font-size: 22px;
}
  #banner1 {
    background-image: url("~@/assets/imgs/editalEletronicoCell.jpg");
    background-repeat: no-repeat;
    height: 546px;
    margin-top: 80px;
    margin-left: -119px;
    max-width: 133%;

}
  #consulta {
    width: 100%;
    background-image: url("~@/assets/imgs/7.jpg") !important;
    background-size: cover;
    background-attachment: scroll;
    height: 100vh;
    overflow: hidden;
    top: 0;
    left: 0;
    /* Preserve aspect ratio */
    min-width: 100%;
    min-height: 100%;
    position: fixed;
}
  #rodapeV {
    height: 234px;
}
  #bt-consultar {
    width: 100%;
    height: 50%;
    font-size: 16px;
    margin-right: 0%;
    margin-top: 37px;
}
  #cpf_ou_cnpj {
    font-size: 19px;
}
  .letraInstProt {
    font-size: 18px;
}
  .letraAtencao {
    font-size: 22px;
}
  #cpf_ou_cnpj {
    font-size: 18px;
    bottom: 20px;
}
#wrapper-input {
    width: 90% !important;
    height: 33% !important;
    margin-left: 5% !important;
}
#cpf_cnpj {
    font-size: 17px;
    margin-top: -14px;
    height: 100%;
}
#wrapper-cpf_cnpj {
    width: 100%;
    height: 70% !important;
  }
}
@media (min-width: 766px) and (max-width: 900px) {
#wrapper-input {
    height: 22%;
    margin-left: 7%;
    width: 86%;
}
#consulta {
    width: 100%;
    background-image: url("~@/assets/imgs/7.jpg") !important;
    background-size: cover;
    background-attachment: scroll;
    height: 100vh;
    overflow: hidden;
    top: 0;
    left: 0;
    /* Preserve aspect ratio */
    min-width: 100%;
    min-height: 100%;
}
#banner1 {
    background-image: url("~@/assets/imgs/editalEletronico4.jpg");
    max-width: 100%;
    height: auto;
    width: 100% !important;
    }
}
@media (min-width: 1200px) and (max-width: 1600px) {
#banner1 {
    background-image: url("~@/assets/imgs/editalEletronico3.jpg");
    height: 966px;
    margin-top: -29px;
}
#wrapper-input {
    border: 2px solid rgb(255, 255, 255) !important;
    width: 71%;
    height: 28% !important;
    margin-left: 15%;
  }
}
.vtm {
    border: none;
    outline-offset: 0px;
    outline: 0px auto -webkit-focus-ring-color;
}
</style>
